/**
 * Segment integration code.
 * See documentation at https://segment.com/docs/sources/website/analytics.js/
 */

module.exports = function (M) {
  const memriseCustomAnalytics = analytics => {
    if (M.DEBUG) {
      analytics.on('track', function (event, properties, options) {
        console.log(
          `SegmentAnalytics --> Event: ${event} -> ${JSON.stringify(
            properties,
          )} -> `,
        );
      });
    }

    if (M.user.is_authenticated) {
      analytics.load(M.SEGMENT_WEB_KEY);

      analytics.ready(function () {
        window.appboy.subscribeToNewInAppMessages(function (
          inAppMessages,
        ) {
          window.appboy.display.showInAppMessage(inAppMessages[0]);
          return inAppMessages.slice(1);
        });
      });
    } else {
      // Delay loading of Braze Integration until user is logged in to prevent anonymous sessions in Braze
      // Braze matches up external ID from this event with user information in the following identify call
      analytics.load(M.SEGMENT_WEB_KEY, {
        integrations: { All: true, Appboy: false },
      });
    }

    if (M.user.is_authenticated) {
      analytics.identify(M.user.id, {
        username: M.user.username,
        is_pro: M.user.is_premium,
      });
    }

    if (M.page_id) {
      analytics.page(M.page_id);
    } else {
      analytics.page();
    }
  };

  !(function () {
    // ===========================
    // SEGMENT CODE SNIPPET STARTS
    // ===========================
    // Link to snippet: https://segment.com/docs/sources/website/analytics.js/quickstart/#step-1-copy-the-snippet

    // Create a queue, but don't obliterate an existing one!
    var analytics = (window.analytics = window.analytics || []);

    // If the real analytics.js is already on the page return.
    if (analytics.initialize) return;

    // If the snippet was invoked already show an error.
    if (analytics.invoked) {
      if (window.console && console.error) {
        console.error('Segment snippet included twice.');
      }
      return;
    }

    // Invoked flag, to make sure the snippet
    // is never invoked twice.
    analytics.invoked = true;

    // A list of the methods in Analytics.js to stub.
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
      'addSourceMiddleware',
      'addIntegrationMiddleware',
      'setAnonymousId',
      'addDestinationMiddleware',
    ];

    // Need to set _cdn for custom domains in Analytics.js 2.0 -
    // this is currently undocumented, we were told to add it by
    // a Segment support engineer.
    analytics._cdn = 'https://evs.analytics.memrise.com';

    analytics.factory = function (method) {
      return function () {
        var args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        analytics.push(args);
        return analytics;
      };
    };

    // For each of our methods, generate a queueing stub.
    for (var i = 0; i < analytics.methods.length; i++) {
      var key = analytics.methods[i];
      analytics[key] = analytics.factory(key);
    }

    // Define a method to load Analytics.js from our CDN,
    // and that will be sure to only ever load it once.
    analytics.load = function (key, options) {
      // Create an async script element based on your key.
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = analytics._cdn + M.SEGMENT_WEB_PATH;

      // Insert our script next to the first script element.
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
      analytics._loadOptions = options;
    };

    analytics._writeKey = M.SEGMENT_WEB_KEY;
    analytics.SNIPPET_VERSION = '4.13.2';
    // =========================
    // SEGMENT CODE SNIPPET ENDS
    // =========================
    // NB: Snippet includes analytics.load() which we handle ourselves in the below function

    memriseCustomAnalytics(analytics);
  })();
};
